/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form, Input, DatePicker, TimePicker, Select, Cascader, InputNumber,
    Icon, Row, Col, Button, Tooltip, Checkbox, Spin, PageHeader, Card, Menu,
    Dropdown, Popover, Modal, Drawer, Upload
} from 'antd';
import { token, getUrlVars, getFileExtension, CheckTokenExp,ReplaceUrlTaga } from '../../../../config';

import TableTagDetail from '../../../../components/Ants/Table/TableTagDetail';
import ModalTagAddMember from '../../../../components/Ants/Modal/ModalTagAddMember';
import ModalSuccess from '../../../../components/Ants/Modal/ModalSuccess';
import ModalWarning from '../../../../components/Ants/Modal/ModalWarning';
import { apiClient } from '../../../../api';
import{root} from '../../../../config';

export default class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            titel: "",
            name: "",
            des: "",
            search: {
                name: "",
                des: "",
            },
            selectedFileList: [],
            action: "",
            Deletelist: [],
            Insertlist: [],
            popoverhide: false,
            TAG_NAME: "",
            screenwidth: 0,
            screenwidth2: 0,
            errorsTag: "",
            exportloading: false,
        }

        this.showModal = this.showModal.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.warningModal = this.warningModal.bind(this);
        this.successModal = this.successModal.bind(this);
        this.modalcountDown = this.modalcountDown.bind(this);
        this.setStateByProps = this.setStateByProps.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.ExportfileToExcel = this.ExportfileToExcel.bind(this);
        this.ExportfileToExcelTemplate = this.ExportfileToExcelTemplate.bind(this);
        this.showDrawerUpload = this.showDrawerUpload.bind(this);
        this.onCloseUpload = this.onCloseUpload.bind(this);
        this.UploadFile = this.UploadFile.bind(this);
        this.dummyRequest = this.dummyRequest.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.handleOnAddTagPerson = this.handleOnAddTagPerson.bind(this);
        this.handleOnDeleteAllTagGroupAssign = this.handleOnDeleteAllTagGroupAssign.bind(this);
        this.handleVisibleChange = this.handleVisibleChange.bind(this);
        this.handleOnSaveTag = this.handleOnSaveTag.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        ReplaceUrlTaga();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions() {
        setTimeout(() => {
            var root = document.getElementById("root");
            if (root) {
                var e = document.getElementById("main");
                var e2 = document.getElementById("main2");
                if (e && e2) {
                    var scroll = root.offsetHeight > window.innerHeight;
                    this.setState({ screenwidth: scroll ? e.offsetWidth - 224 : e.offsetWidth - 224 });
                    this.setState({ screenwidth2: scroll ? e2.offsetWidth - 124 : e2.offsetWidth - 124 });
                }
            }
        }, 500);
    }

    showModal() {
        this.setState({
            visible: true
        });


        this.onSearch();
    };

    handleOk(e) {
        this.setState({
            visible: false,
        });
    };

    handleCancel(e) {
        this.setState({
            visible: false,
        });
    };

    warningModal(value, message, messageSuccess) {
        this.setState({ warningModalVisible: value, message, messageSuccess });
    }

    successModal(value) {
        if (this.state.action == "uplaod") {
            this.UploadFile();
            this.setState({ action: "", successModalVisible: value });
        }
        if (this.state.action == "addperson") {
            this.handleOnAddTagPerson();
            this.setState({ visible: false });
            this.setState({ action: "", successModalVisible: value });
        }
        if (this.state.action == "delete") {
            this.handleOnDeleteAllTagGroupAssign();
            this.setState({ action: "", successModalVisible: value });
        }

        if (this.state.action == "discard") {
            this.setState({ action: "", successModalVisible: value });
            value = false;
            this.props.history.push('/people/tag/')

        }

        if (this.state.action == "addtag") {
            this.handleOnSaveTag();
            this.setState({ action: "" });
        }

        //this.setState({ successModalVisible: value });

    }

    modalcountDown() {
        let secondsToGo = 2;
        this.setState(state => {
            if (state.successModalVisible) {
                setTimeout(() => {
                    this.setState({ successModalVisible: false });
                }, secondsToGo * 1000);
            }
        });
    }

    setStateByProps(parameters, value) {
        value ? value : "";
        this.setState({ [parameters]: value });
    }

    onSearch() {
        this.setState(state => {
            return {
                search: {
                    name: state.name,
                    des: state.des,
                }
            }
        });
        this.updateWindowDimensions();
    }

    ExportfileToExcel() {
        if (!CheckTokenExp()) {
            this.setState({ exportloading: true })
            let req = JSON.stringify({
                "PRG_ID": getUrlVars()["id"],
                "SEARCH": this.state.name,
                "DEST": this.state.des,
                "TAGNAME": this.state.titel,
            });

            apiClient.post('api/Tag/EXPORT/', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    },
                    responseType: 'blob',
                })
                .then(data => {
                    var json = data.data;
                    this.setStateByProps("active", "");
                    const url = window.URL.createObjectURL(new Blob([json]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = "TagPerson.xlsx";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.setState({ exportloading: false });
                })
                .catch(error => {
                    var errorMsg = error;
                    this.setState({ exportloading: false });
                });
        } else {
            window.location.href = "logout";
        }
        
    }

    ExportfileToExcelTemplate() {
        if (!CheckTokenExp()) {
            this.setState({ exportloading: true })

            apiClient.get('api/Tag/EXPORT_TEMPLATE/'
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    },
                    responseType: 'blob',
                })
                .then(data => {
                    var json = data.data;

                    const url = window.URL.createObjectURL(new Blob([json]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = "TagPerson_Template.xlsx";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.setState({ exportloading: false });
                })
                .catch(error => {

                    this.setState({ exportloading: false });
                });
        } else {
            window.location.href = "logout";
        }
        
    }

    showDrawerUpload() {
        this.setState({
            visibleUpload: true,
        });

    };

    onCloseUpload() {
        this.setState({
            visibleUpload: false,
        });
    };

    onUpload(info) {
        if (info.file.size <= 1048576) {
            const nextState = {};
            switch (info.file.status) {
                case "uploading":
                    if (getFileExtension(info.file.name) == "xlsx" || getFileExtension(info.file.name) == "xls") {
                        nextState.selectedFileList = [info.file];
                    } else {
                        this.onCloseUpload();
                        Modal.error({
                            title: 'The file format is incorrect.',
                            className: 'popup-error',
                            content: (
                                <div>
                                    <p>Check and upload the file again.</p>
                                </div>
                            ),
                            onOk() { },
                        });

                        nextState.selectedFile = null;
                        nextState.selectedFileList = [];
                    }
                    break;
                case "done":
                    if (getFileExtension(info.file.name) == "xlsx" || getFileExtension(info.file.name) == "xls") {
                        nextState.selectedFile = info.file;
                        nextState.selectedFileList = [info.file];
                    } else {
                        nextState.selectedFile = null;
                        nextState.selectedFileList = [];
                    }
                    break;
                default:
                    // error or removed
                    nextState.selectedFile = null;
                    nextState.selectedFileList = [];
            }
            this.setState(() => nextState);
        }
    };

    dummyRequest({ file, onSuccess }) {
        if (file.size <= 1048576) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                this.setState({ filename: file.name, result: reader.result.split(',')[1], filetype: file.type });
            }.bind(this);

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };

            setTimeout(() => {
                onSuccess("ok");
            }, 0);
        }
        else {
            Modal.error({
                className: 'popup-error',
                title: 'Error',
                onOk: () => Modal.destroyAll(),
                content: "File size limit 1 MB",
                icon: <Icon type="exclamation-circle-o" style={{ fontSize: 36 }} />,
                zIndex: 1300
            });
        }
    };

    UploadFile() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true, uploading: true })
            let req = JSON.stringify({
                "ID": getUrlVars()["id"],
                "filebase64": this.state.result,
                "filetype": this.state.filetype,
                "filename": this.state.filename
            });

            apiClient.post('api/Tag/IMPORTNEW', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    var json = data.data;
                    if (data.data) {
                        this.setState({
                            loading: false,
                            uploading: false,
                            visibleUpload: false,
                            selectedFileList: [],
                            SEARCH: "",
                            current: 1,
                            minpage: 1,
                            pagesize: 50,
                        });
                        this.onSearch();

                        // if(json.insert == "0"){
                        //     Modal.info({
                        //         className: 'popup-question',
                        //         title: 'Infomation',
                        //         onOk: () => Modal.destroyAll(),
                        //         content:
                        //             <div>
                        //                 Duplicate data or invalid format
                        //             </div>,
                        //         icon: <Icon type="exclamation-circle-o" style={{ fontSize: 36 }} />,
                        //         zIndex: 1300
                        //     });
                        // }else{
                        Modal.success({
                            className: 'popup-success',
                            title: 'Success',
                            onOk: () => Modal.destroyAll(),
                            content:
                                <div>
                                    <p className="ant-margin-p">Insert {json.insert} records</p>
                                </div>,
                            icon: <Icon type="exclamation-circle-o" style={{ fontSize: 36 }} />,
                            zIndex: 1300
                        });
                        // }

                        this.setStateByProps("action", "")
                        this.setState({ loading: false });
                    }else{
                        throw new error
                    }

                })
                .catch(error => {
                    this.setState({ loading: false });
                    Modal.error({
                        className: 'popup-error',
                        title: 'Error',
                        onOk: () => Modal.destroyAll(),
                        content: 'Import File Failed No of column incorrect',
                        icon: <Icon type="close-circle" style={{ fontSize: 36 }} />,
                        zIndex: 1300
                    });
                });
        } else {
            window.location.href = "logout";
        }

    }

    /* UploadFile() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true, uploading: true })
            let req = JSON.stringify({
                "ID": getUrlVars()["id"],
                "filebase64": this.state.result,
                "filetype": this.state.filetype
            });

            apiClient.post('api/Tag/IMPORT/', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    var json = data.data;

                    this.setState({
                        loading: false,
                        uploading: false,
                        visibleUpload: false,
                        selectedFileList: [],
                        SEARCH: "",
                        current: 1,
                        minpage: 1,
                        pagesize: 50,
                    });
                    this.onSearch();

                    // if(json.insert == "0"){
                    //     Modal.info({
                    //         className: 'popup-question',
                    //         title: 'Infomation',
                    //         onOk: () => Modal.destroyAll(),
                    //         content:
                    //             <div>
                    //                 Duplicate data or invalid format
                    //             </div>,
                    //         icon: <Icon type="exclamation-circle-o" style={{ fontSize: 36 }} />,
                    //         zIndex: 1300
                    //     });
                    // }else{
                        Modal.success({
                            className: 'popup-success',
                            title: 'Success',
                            onOk: () => Modal.destroyAll(),
                            content:
                                <div>
                                    <p className="ant-margin-p">Insert {json.insert} records</p>
                                </div>,
                            icon: <Icon type="exclamation-circle-o" style={{ fontSize: 36 }} />,
                            zIndex: 1300
                        });
                    // }
                   
                    this.setStateByProps("action", "")
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ loading: false });
                    Modal.error({
                        className: 'popup-error',
                        title: 'Error',
                        onOk: () => Modal.destroyAll(),
                        content: 'Import File Failed No of column incorrect',
                        icon: <Icon type="close-circle" style={{ fontSize: 36 }} />,
                        zIndex: 1300
                    });
                });
        } else {
            window.location.href = "logout";
        }
        
    } */

    handleOnAddTagPerson() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })
            let req = JSON.stringify({
                PERSON: this.state.Insertlist,
                PRS_PRG: getUrlVars()["id"],
            });


            apiClient.post('api/Tag/MANAGE_TAGPERSONS', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {
                    //var json = data.data;

                    this.setState({
                        //PRS_PRG: json.PRS_PRG,
                        loading: false,
                        Insertlist: [],
                        listview: "block",
                        detialview: "none",
                        dest: "",
                        name: ""
                    }, function () {
                        setTimeout(() => {
                            this.setState({
                                loading: false,
                                SEARCH: "",
                                current: 1,
                                minpage: 1,
                                pagesize: 50,
                            })
                            //this.RequestInfoTagsTagGroupAssign()
                        }, 100);
                    })

                    this.onSearch();

                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        SEARCH: "",
                        current: 1,
                        minpage: 1,
                        pagesize: 50,
                    })
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }
        
    }

    handleOnDeleteAllTagGroupAssign() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true })
            let req = JSON.stringify({
                TAGGROUP: this.state.Deletelist,
            });


            apiClient.post('api/Tag/DELETE_ALL_TAGGROUPASSIGN', req
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8'
                    }
                })
                .then(data => {

                    this.setState({
                        Deletelist: [],
                        selectedRowKeys: [],
                    }, function () {
                        setTimeout(() => {
                            this.setState({ loading: false })
                            //this.RequestInfoTagsTagGroupAssign();
                        }, 100);
                    });

                    this.onSearch();
                    this.setState({ loading: false });
                })
                .catch(error => {

                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }

    }

    handleVisibleChange(value) {
        this.setState({ popoverhide: this.state.titel == "" ? false : value });
    };

    handleOnSaveTag() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true, errorsTag: "" })

            if (getUrlVars()["id"]) {
                let req = JSON.stringify({
                    PRG_ID: getUrlVars()["id"],
                    PRG_NAME: this.state.TAG_NAME
                });

                apiClient.post('api/Tag/UPDATE_TAG', req
                    , {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-type': 'application/json; charset=UTF-8'
                        }
                    })
                    .then(data => {
                        var json = data.data;

                        if (json.PRG_ID) {
                            var id = json.PRG_ID
                            window.history.replaceState(null, null, "/people/tag/detail?id=" + id);
                            this.onSearch();
                            this.setState({ successModalVisible: true });
                            setTimeout(() => {
                                this.setState({ successModalVisible: false });
                            }, 2000);
                        }
                        else {
                            this.setState({ errorsTag: "Duplicate Tag", successModalVisible: false })
                        }

                        this.setState({ loading: false });
                    })
                    .catch(error => {
                        this.setState({ loading: false, successModalVisible: false });
                    });
            } else {
                let req = JSON.stringify({
                    PRG_NAME: this.state.TAG_NAME
                });

                apiClient.post('api/Tag/INSERT_TAGNAME', req
                    , {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-type': 'application/json; charset=UTF-8'
                        }
                    })
                    .then(data => {
                        var json = data.data;

                        if (json.PRG_ID != 0) {
                            var id = json.PRG_ID
                            window.history.replaceState(null, null, "/people/tag/detail?id=" + id);
                            this.onSearch();
                            this.setState({ successModalVisible: true });
                            setTimeout(() => {
                                this.setState({ successModalVisible: false });
                            }, 2000);
                        }
                        else {
                            this.setState({ errorsTag: "Duplicate Tag", successModalVisible: false })
                        }

                        this.setState({ loading: false });
                    })
                    .catch(error => {
                        this.setState({ loading: false, successModalVisible: false });
                    });

            }
        } else {
            window.location.href = "logout";
        }
        
    }



    render() {
        const { loading, message, messageSuccess, warningModalVisible, successModalVisible, titel,
            search, dest, name, Deletelist, Insertlist, popoverhide, TAG_NAME, screenwidth, screenwidth2, errorsTag } = this.state;
        const { visible } = this.state;
        const routes = [
            {
                path: '/people',
                breadcrumbName: 'People',
            },
            {
                path: 'tag/',
                breadcrumbName: 'Tag',
            },
            {
                breadcrumbName: titel ? "Edit" : "New",
            },
        ];

        var styleinput_tagName = {
            width: screenwidth,
            marginRight: 8,
            marginBottom: 8,
            minWidth: 200
        };
        var styleinput_name = {
            width: (screenwidth2 / 2),
            marginRight: 8,
            marginBottom: 8,
            minWidth: 200
        };
        var styleinput_destination = {
            width: (screenwidth2 / 2),
            marginRight: 8,
            marginBottom: 8,
            minWidth: 200
        };

        const props = {
            showUploadList: {
                showDownloadIcon: false,
                showRemoveIcon: true,
            },
        };
        return (
            <Spin spinning={this.state.exportloading}>
                <div>
                    <PageHeader breadcrumb={{ routes }} >
                    </PageHeader>

                    <div className="content">
                        <Card >
                            <Row gutter={8}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    <label className=" control-label require" style={{ fontWeight: 700 }}> Tag Name</label>
                                </Col>
                            </Row>

                            <Row gutter={8} className="row-nowrap" id="main">
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>

                                    <Input style={styleinput_tagName} value={TAG_NAME} name="TAG_NAME" placeholder="Tag Name"
                                        onChange={(e) => {
                                            this.setStateByProps("TAG_NAME", e.currentTarget.value)
                                        }} />
                                    <Button type="primary" style={{ marginRight: 8 }} disabled={TAG_NAME ? false : true}
                                        onClick={() => { this.setState({ errorsTag: "" }), this.warningModal(true, "Do you want to add this tag?", "Add tag successfully."), this.setStateByProps('action', 'addtag') }}>
                                        <span className="fa fa-plus-circle"></span> &nbsp;&nbsp;
                                                    Save
                                </Button>
                                    <Button key="submit"
                                        onClick={() => { this.warningModal(true, "Do you want to discard change?", "Discarded change successfully."), this.setState({ action: "discard" }) }}>
                                        <span className="fa fa-trash-o"></span> &nbsp;&nbsp;
                                       Discard
                                </Button>


                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {
                                        errorsTag ?
                                            <label className="error" style={{ fontWeight: 700, color: 'red' }}>{errorsTag}</label> :
                                            <label className="unerror" style={{ fontWeight: 700, color: 'red' }}>&nbsp;&nbsp;</label>
                                    }
                                </Col>

                            </Row>
                        </Card>

                        <Card style={{ minHeight: 200 }} >

                            <Row gutter={8} type="flex" justify="space-between">
                                <Col xs={12}>
                                    <Button key="submit" style={{ marginRight: 8 }}
                                        disabled={Deletelist.length > 0 ? false : true}
                                        onClick={() => { this.warningModal(true, "Do you want to delete this member?", "Deleted member successfully."), this.setStateByProps("action", "delete") }}>
                                        <span className="fa fa-trash-o"></span> &nbsp;&nbsp;
                                       Delete
                        </Button>
                                </Col>
                                <Col xs={12}>
                                    <div style={{ float: "right" }}>
                                        <Popover placement="bottomRight" visible={popoverhide}
                                            onVisibleChange={(e) => this.handleVisibleChange(e)}
                                            content={
                                                <Menu>
                                                    <Menu.Item style={{ borderBottom: '1px solid #7b7b7b' }} onClick={this.showModal} disabled={titel ? false : true}>
                                                        <span className="fa fa-plus-circle size14"></span> &nbsp;&nbsp;  Add
                                                    </Menu.Item>
                                                    <Menu.Item style={{ borderBottom: '1px solid #7b7b7b' }} onClick={this.ExportfileToExcel}>
                                                        <span className="fa fa-cloud-download size14"></span> &nbsp;&nbsp;  Export File
                                                    </Menu.Item>
                                                    <Menu.Item style={{ borderBottom: '1px solid #7b7b7b' }} onClick={() => { this.handleVisibleChange(false), this.showDrawerUpload() }}>
                                                        <span className="fa fa-cloud-upload iconsize size14"></span> &nbsp;&nbsp;  Import File
                                                    </Menu.Item>
                                                    <Menu.Item style={{ borderBottom: '1px solid #7b7b7b' }} onClick={this.ExportfileToExcelTemplate}>
                                                        <span className="fa fa-file-o iconsize size14"></span> &nbsp;&nbsp;  Download Template
                                                 </Menu.Item>
                                                </Menu>} trigger="click">

                                            <Button disabled={titel ? false : true}> <span className="fa fa-list"></span> &nbsp;&nbsp; Action</Button>

                                        </Popover>

                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={8} type="flex" justify="center" className="row-nowrap" id="main2">
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                    <Input placeholder="Name" style={styleinput_name} onChange={(e) => this.setStateByProps("name", e.target.value)} />
                                    <Input placeholder="Destination" style={styleinput_destination} onChange={(e) => this.setStateByProps("des", e.target.value)} />

                                    <Button icon="search" onClick={this.onSearch} >
                                        Search
                         </Button>
                                </Col>

                            </Row>

                            <Row gutter={8} type="flex" justify="space-between">
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <TableTagDetail
                                        warningModal={this.warningModal}
                                        setStateByProps={this.setStateByProps}
                                        search={search}
                                        updateWindowDimensions={this.updateWindowDimensions}
                                    />
                                </Col>
                            </Row>

                        </Card>
                    </div>

                    <Drawer
                        className="boy-drawer"
                        style={{ zIndex: 1022 }}
                        title={<h3>Upload File</h3>}
                        placement={this.state.placementUpload}
                        height={'auto'}
                        closable={false}
                        onClose={this.onCloseUpload}
                        visible={this.state.visibleUpload}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Upload {...props}
                                    id="input"
                                    accept=".xlsx"
                                    fileList={this.state.selectedFileList}
                                    customRequest={this.dummyRequest}
                                    onChange={this.onUpload}
                                    style={{ width: "100%" }}
                                >
                                    <Button style={{ width: "100%" }}><Icon type="import" /> IMPORT FILE</Button>
                                </Upload>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    onClick={this.UploadFile}
                                    style={{ marginTop: 16 }}
                                    disabled={this.state.selectedFileList.length == 0}
                                >
                                    {loading ? 'UPLOADING' : 'START UPLOAD'}
                                </Button>
                                <label class=" control-label require">File type * xlsx maximum upload file size total 1 MB</label>
                            </Col>
                        </Row>
                    </Drawer>

                    <ModalTagAddMember
                        visible={visible}
                        handleOk={this.handleOk}
                        handleCancel={this.handleCancel}
                        warningModal={this.warningModal}
                        setStateByProps={this.setStateByProps}
                        Insertlist={Insertlist}
                        loading={loading}
                    />

                    <ModalWarning loading={loading}
                        warningModalVisible={warningModalVisible}
                        warningModal={this.warningModal}
                        successModal={this.successModal}
                        modalcountDown={this.modalcountDown}
                        message={message}
                        messageSuccess={messageSuccess}
                    />

                    <ModalSuccess loading={loading}
                        successModalVisible={successModalVisible}
                        successModal={this.successModal}
                        messageSuccess={messageSuccess}
                    />

                </div >
            </Spin>
        );
    }
}


